import { ElementRef, OnInit } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { VisitorDataCache } from '../../../stores/visitor.calendar.store';
var ImageComponent = /** @class */ (function () {
    function ImageComponent(imageService) {
        this.imageService = imageService;
        this.alt = 'picture';
        this.width = 'auto';
        this.height = 'auto';
        this.isContainImage = false;
        this.defaultImgUrl = 'https://imgoingcalendar.com/assets/imgs/place-holder.jpg';
    }
    ImageComponent.prototype.ngOnInit = function () {
        // if (!this.imageUrl) {
        //     this.setDefaultImageForPlace();
        // }
        this.isContainImage = !this.imageUrl;
        this.imageUrl = this.imageService.safeImage(this.imageService.imageSourceUrl(this.imageUrl));
    };
    ImageComponent.prototype.error = function () {
        // console.log(`image loading error: ${this.imageUrl}`);
        // if (this.isPlace) {
        //     this.setDefaultImageForPlace();
        // } else {
        //     this.imageUrl = this.defaultImgUrl;
        // }
        this.isContainImage = true;
        this.imageUrl = this.imageService.safeImage(this.imageService.imageSourceUrl(''));
        //this.imageUrl = this.defaultImgUrl;
        //that.onerror=null;
    };
    ImageComponent.prototype.loaded = function () {
        this.isContainImage = false;
    };
    Object.defineProperty(ImageComponent.prototype, "isPlace", {
        get: function () {
            return this.placeCategoryList && this.placeCategoryList.length;
        },
        enumerable: true,
        configurable: true
    });
    ImageComponent.prototype.setDefaultImageForPlace = function () {
        if (this.isPlace) {
            var category = null;
            console.log(JSON.stringify(this.placeCategoryList));
            var _loop_1 = function (key) {
                if (VisitorDataCache.placeCategories[key] && this_1.placeCategoryList.any(function (x) { return VisitorDataCache.placeCategories[key].any(function (y) { return x === y; }); })) {
                    category = key;
                    return "break";
                }
            };
            var this_1 = this;
            for (var key in VisitorDataCache.placeCategories) {
                var state_1 = _loop_1(key);
                if (state_1 === "break")
                    break;
            }
            console.log("this category: " + category);
            var array = config.placeDefaultImages[category];
            if (array && array.length) {
                this.imageUrl = config.placeDefaultImages[category].getRandom();
            }
            else {
                this.imageUrl = this.defaultImgUrl;
            }
        }
    };
    ImageComponent.prototype.updateImage = function (img) {
        var _this = this;
        setTimeout(function () {
            var url = _this.imageService.imageSourceUrl(img);
            _this.imageUrl = _this.imageService.safeImage(url);
        });
    };
    ImageComponent.prototype.getRect = function () {
        if (this.imageEle) {
            var rect = this.imageEle.nativeElement.getBoundingClientRect();
            return rect;
        }
    };
    ImageComponent.prototype.setHeight = function (height) {
        this.height = height + "px";
        if (this.imageEle) {
            this.imageEle.nativeElement.style.transition = '100ms';
            this.imageEle.nativeElement.style.height = height + "px";
        }
    };
    return ImageComponent;
}());
export { ImageComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image/image.component.ts.pre-build-optimizer.js